import type { MemoryBankSupportedEntityTypes } from '@erp/rpc';
import { SystemEntity } from '@erp/shared-types';
import SupplierPill from '@/components/company/SupplierPill';
import CustomerPill from '@/components/customer/CustomerPill';

interface MemoryBankEntityPillProps {
  entityType: MemoryBankSupportedEntityTypes;
  entityId: string;
}

export function MemoryBankEntityPill({
  entityType,
  entityId,
}: MemoryBankEntityPillProps) {
  switch (entityType as SystemEntity) {
    case SystemEntity.AR_CUSTOMER:
      return <CustomerPill customerId={entityId} />;
    case SystemEntity.AP_SUPPLIER:
      return <SupplierPill supplierId={entityId} />;
    default:
      return null;
  }
}
